import React, { Dispatch, SetStateAction } from "react";
import { Input } from "../../../../../Input/Input";
import { FaqDetailLabel, FaqDetailRow } from "../ManageFaqDetailInput";

interface FaqTagInputProps {
  tag: string;
  setTag: Dispatch<SetStateAction<string>>;
  isEditMode: boolean;
}

export default function FaqTagInput({
  tag,
  setTag,
  isEditMode,
}: FaqTagInputProps) {
  return (
    <FaqDetailRow>
      <FaqDetailLabel>태그(선택)</FaqDetailLabel>

      <Input
        style={{ width: "calc(100% - 148px)" }}
        placeholder="직접 입력. 예)#넷플릭스 프리미엄#파티장"
        value={tag}
        onChange={(e) => setTag(e.target.value)}
        disabled={!isEditMode}
      />
    </FaqDetailRow>
  );
}
